import React, { Suspense, lazy } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import WhatsAppButton from "../components/WhatsAppButton";
import Chatbot from "../components/Chatbot";

const Services = lazy(() => import("../components/Services"));
const Team = lazy(() => import("../components/Team"));
const AtelierSequence = lazy(() => import("../components/AtelierSequence"));
const Partners = lazy(() => import("../components/Partners"));
const Reviews = lazy(() => import("../components/Reviews"));
const Instagram = lazy(() => import("../components/Instagram"));
const Contact = lazy(() => import("../components/Contact"));
const Footer = lazy(() => import("../components/Footer"));

const SectionFallback = () => <div className="min-h-[40vh]" aria-hidden="true" />;

export default function Home() {
  return (
    <div className="relative grain bg-[var(--rf-bg)] text-white">
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={<SectionFallback />}>
          <Services />
          <Team />
          <AtelierSequence />
          <Partners />
          <Reviews />
          <Instagram />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={<SectionFallback />}>
        <Footer />
      </Suspense>
      <WhatsAppButton />
      <Chatbot />
    </div>
  );
}
